import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ExpandButton } from "./Button.styles";
export var Button = function(param) {
    var label = param.content.label, onClick = param.onClick, rules = param.rules;
    var ref = rules || {}, _expanded = ref.expanded, expanded = _expanded === void 0 ? false : _expanded, tmp = ref.horizontalSpacing, ref1 = tmp === void 0 ? {} : tmp, _isCentered = ref1.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, _size = ref.size, size = _size === void 0 ? "large" : _size, _variant = ref.variant, variant = _variant === void 0 ? "primary" : _variant, tmp1 = ref.verticalSpacing, ref2 = tmp1 === void 0 ? {} : tmp1, _spacingDirection = ref2.spacingDirection, spacingDirection = _spacingDirection === void 0 ? "bottom" : _spacingDirection;
    return /*#__PURE__*/ _jsx(ExpandButton, {
        size: size,
        variant: variant,
        isCentered: isCentered,
        isExpanded: expanded,
        spacingDirection: spacingDirection,
        onClick: onClick,
        children: label
    });
};
